import React from 'react'
// Redux
import { Provider } from 'react-redux'
import { Switch, Route, BrowserRouter } from 'react-router-dom'
import { PersistGate } from 'redux-persist/integration/react'
import { persistStore } from 'redux-persist'
import GAListener from './components/GAListener';
import Loading from './components/loading';

// Redux
import { store } from './store'

import HomeScreen from './containers/homeScreen';
import RegisterScreen from './containers/registerScreen';
import SingleResultScreen from './containers/testResults/singleResultScreen';
import LoginScreen from './containers/loginScreen';
import ErrorScreen from './containers/errorScreen';
import ResetPasswordScreen from './containers/resetPasswordRequestScreen'
import UsernameRequestScreen from './containers/usernameRequestScreen'
import ChangePasswordScreen from './containers/changePasswordScreen'
import ForgotPassword from './containers/forgotPasswordScreen'
import EmailVerificationScreen from './containers/emailVerificationScreen'
import SuccessfulRegScreen from './containers/successfulRegScreen'
import ImmunizationScreen from './containers/immunizationScreen'
import PageTitleHandler from './components/pageTitleHandler'
import LangParamHandler from './components/langParamHandler'

class App extends React.Component {
    constructor() {
        super();
        this.persistor = persistStore(store);
    }

    render() {
        return (
            <Provider store={store}>
                <PersistGate loading={null} persistor={this.persistor}>
                    <BrowserRouter basename="/manitoba">
                        <LangParamHandler />
                        <PageTitleHandler />
                        <GAListener>
                            <Switch>
                                <Route exact path="/" component={LoginScreen} />
                                <Route path="/login" component={LoginScreen} />
                                <Route path="/app" component={HomeScreen} />
                                <Route path="/register" component={RegisterScreen} />
                                <Route path="/successful_register" component={SuccessfulRegScreen} />
                                <Route path="/email_validation" component={EmailVerificationScreen} />
                                <Route path="/changePassword" component={ChangePasswordScreen} />
                                <Route path="/error" component={ErrorScreen} />
                                <Route path="/resetPasswordRequest" component={ResetPasswordScreen} />
                                <Route path="/forgot_password" component={ForgotPassword} />
                                <Route path="/usernameRequest" component={UsernameRequestScreen} />
                                <Route path="/results" component={SingleResultScreen} />
                                <Route path="/immunizations" component={ImmunizationScreen} />
                            </Switch>
                        </GAListener>
                    </BrowserRouter>
                </PersistGate>
            </Provider>
        )
    }
}



export default App;
